/**
 * @generated SignedSource<<66cd6416b55761810bcabaeaa23726f8>>
 * @relayHash c8257d74afaa8e2a4de1b61f4752e171
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 71c4e49904469f656bf1a9edb542eb4f4a559d8a265dd802b3e7ae36a1a084cb

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AccountStatus = "active" | "closed" | "inactive" | "%future added value";
export type JiraMultiValueFieldOperations = "ADD" | "REMOVE" | "SET" | "%future added value";
export type JiraUpdateMultipleSelectUserPickerFieldInput = {
  id: string;
  operations: ReadonlyArray<JiraMultipleSelectUserPickerFieldOperationInput>;
};
export type JiraMultipleSelectUserPickerFieldOperationInput = {
  ids: ReadonlyArray<string>;
  operation: JiraMultiValueFieldOperations;
};
export type multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation$variables = {
  input: JiraUpdateMultipleSelectUserPickerFieldInput;
};
export type multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation$data = {
  readonly jira: {
    readonly updateMultipleSelectUserPickerField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly " $fragmentSpreads": FragmentRefs<"multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateMultipleSelectUserPickerField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly fieldId: string;
        readonly id: string;
        readonly name: string;
        readonly selectedUsersConnection: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly __typename: "AtlassianAccountUser";
              readonly accountId: string;
              readonly accountStatus: AccountStatus;
              readonly email: string | null | undefined;
              readonly id: string;
              readonly name: string;
              readonly picture: AGG$URL;
            } | {
              readonly __typename: string;
              readonly accountId: string;
              readonly accountStatus: AccountStatus;
              readonly id: string;
              readonly name: string;
              readonly picture: AGG$URL;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly type: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation = {
  rawResponse: multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation$rawResponse;
  response: multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation$data;
  variables: multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraMultipleSelectUserPickerFieldPayload",
            "kind": "LinkedField",
            "name": "updateMultipleSelectUserPickerField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraMultipleSelectUserPickerField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "multiUserPicker_issueFieldMultiUserPickerInlineEditFull_MultiUserPickerInlineEditViewWithIsEditable_fragmentRef"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraMultipleSelectUserPickerFieldPayload",
            "kind": "LinkedField",
            "name": "updateMultipleSelectUserPickerField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraMultipleSelectUserPickerField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "fieldId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "concreteType": "JiraUserConnection",
                    "kind": "LinkedField",
                    "name": "selectedUsersConnection",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "accountId"
                              },
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "picture"
                              },
                              (v4/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "accountStatus"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "email"
                                  }
                                ],
                                "type": "AtlassianAccountUser"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "71c4e49904469f656bf1a9edb542eb4f4a559d8a265dd802b3e7ae36a1a084cb",
    "metadata": {},
    "name": "multiUserPicker_issueFieldMultiUserPicker_MultiUserPickerField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "66516ecfc9f74fa693150553eb2bae7f";

export default node;
